<ng-container
  *ngrxLet="{
    tmpPackage: package$,
    singlePackagingResource: singlePackagingResource$,
    validationResource: validationResource$,
    packageTypes: packageTypes$,
    packagingUnCodes: packagingUnCodes$
  } as vm"
>
  <hazmatsuite-next-dangerousgood-selection
    *ngIf="!vm.tmpPackage?.DangerousGood; else details"
    [showCancelButton]="true"
    [showLoadFromArticles]="true"
    [transportMode]="transportMode"
    [excludedDgClasses]="[7]"
    (selectDangerousGood)="selectDangerousGood($event)"
  ></hazmatsuite-next-dangerousgood-selection>

  <ng-template #details>
    <form [formGroup]="formGroup" *ngIf="formGroup">
      <lib-easydgd-single-package-form
        [singlePackagingModel]="model"
        defaultPackageType="1"
        [packageTypes]="vm.packageTypes"
        [packagingUnCodes]="vm.packagingUnCodes"
        (formValueChange)="formValueChange($event)"
      ></lib-easydgd-single-package-form>
    </form>
  </ng-template>
</ng-container>
